import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CamperService from '../../api/services/CamperService';
import MainPagetitle from '../../layouts/MainPagetitle';
import PriceService from '../../api/services/PriceService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const AddPrice = () => {
  const navigate = useNavigate();
  const [isLoading, setisloading] = useState(true);
  const [error, setError] = useState("")
  const [camper, setCamper] = useState([]);
  const getCamper = async () => {
    try {
      let camper = await CamperService.index().json();

      var responsedata = camper.data.filter(function (item) {
        return item.camper_type_id == 1
      });
      setCamper(responsedata);
      //setCamper(responsedata);

      //setCamper(camper.data);
      setisloading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (localStorage.getItem("admintoken")) {
    getCamper();
  }
  else {
      navigate('/')
  }
  }, []);
  const onSubmitForm = async (event) => {
    event.preventDefault();
    try {
      var userData = {
        "title": event.target.title.value,
        "start_date": event.target.start_date.value,
        "end_date": event.target.end_date.value,
        "percentage": event.target.percentage.value,
        "camper_id": event.target.camper_id.value,
      }
      let responseData = await PriceService.store(userData).json()
      if (responseData.status === true) {

        navigate("/admin/pricing_management");
      }
    } catch (error) {

      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        
        if (errorJson.message) {
          setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
        }
        else {
          setError(errorJson.msg)
        }


      }
      else {
        console.log(error)
      }
    }

  };

  return (
    <>
      <MainPagetitle mainTitle="Pricing" pageTitle={'Pricing'} parentTitle={'Home'} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add Pricing</h4>
              </div>
              <div className="card-body">
                <form className="form-valide" onSubmit={onSubmitForm}>
                  <div className="row">

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >StartDate<span className="text-danger">*</span></label>
                      <input type="date" className="form-control" name='start_date' id="val-username"
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >EndDate<span className="text-danger">*</span></label>
                      <input type="date" className="form-control" name='end_date' id="val-username"
                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Percentage<span className="text-danger">*</span></label>
                      <input type="number" className="form-control" name='percentage' id="val-username"
                        min={0} />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="exampleFormControlInput2" className="form-label"> Select Camper <span className="text-danger">*</span></label>
                      <select className="form-control" id="val-skill" name="camper_id" >
                        {camper.map((row, index) =>
                          <option key={index} value={row.id}>{row.title} </option>
                        )}
                      </select>
                    </div>
                  </div>
                  <h5 style={{ color: 'red' }}>{error}</h5>
                  <div>
                    <button type="submit" className="btn btn-primary me-1">Submit</button>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div >
      </div >
      {isLoading && <LogoAnimationLoader />}
    </>
  );
};
export default AddPrice;